export const POST_LOGIN_ROUTE_KEY = "psi360_post_login_route";

export const setPostLoginRoute = (route) => {
  sessionStorage.setItem(POST_LOGIN_ROUTE_KEY, route);
};

export const consumePostLoginRoute = () => {
  const route = sessionStorage.getItem(POST_LOGIN_ROUTE_KEY);
  if (route) sessionStorage.removeItem(POST_LOGIN_ROUTE_KEY);
  return route;
};
